import { useContext, useMemo } from 'react';
import FavoritesContext from '~/contexts/FavoritesContext';
import InventoryContext from '~/contexts/InventoryContext';
import type { ConditionalTile, Vehicle } from '~/contracts';
import useConditionalTiles, {
  injectConditionalTiles
} from '~/hooks/useConditionalTiles';

export default function useTiles(
  shouldLoad: boolean
): Array<ConditionalTile | Vehicle> {
  const conditionalTiles = useConditionalTiles();
  const { inventory } = useContext(InventoryContext);
  const { favorites } = useContext(FavoritesContext);

  return useMemo<Array<ConditionalTile | Vehicle>>(() => {
    if (
      !shouldLoad ||
      !inventory.isLoaded ||
      !inventory.data.inventory.vehicles.length
    ) {
      return [];
    }

    const vehicles = inventory.data.inventory.vehicles.map<Vehicle>(
      vehicle => ({
        ...vehicle,
        isFavorite: favorites.some(v => v.vehicleId === vehicle.vehicleId)
      })
    );

    return injectConditionalTiles(vehicles, conditionalTiles);
  }, [
    conditionalTiles,
    favorites,
    inventory.data.inventory.vehicles,
    inventory.isLoaded,
    shouldLoad
  ]);
}
